import Vue from 'vue'
import App from './App'
import store from './store'

// 引入路由器
import router from './router/index'

router.afterEach((to, from) => {
  window.scrollTo(0,0);
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "LightCourse";
  }
})


// 引入js文件，这里直接使用的是这个文件里的路径，不需要再resolver中修改路径之类的操作
import semantic from '../node_modules/semantic-ui-css/semantic.min.js'
// 引入css文件
import '../node_modules/semantic-ui-css/semantic.min.css'

Vue.use(semantic);


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en.js';
Vue.use(ElementUI, {locale});

import "./assets/js/jquery.share.min";
import "./assets/css/share.min.css";

// 配置图片懒加载
import VueLazyload from 'vue-lazyload'
import loading from './common/img/loading.gif'
Vue.use(VueLazyload, {
  loading
});

// 引入全局过滤器
import '@/config/filters'

import "./assets/css/swiper.min.css";
import "./assets/css/animate.css";
import "./assets/css/font_3136242_62t986otkc6.css";
import "./assets/js/font_3136242_11ioew7dvwo";
import "./assets/css/common.css";
import "./assets/js/jquery-ui.min.js";
import "./assets/js/jquery.cookie";
// import "./assets/js/common"
import "./assets/layer/layer";
import "./assets/layer/theme/default/layer.css"
import JsEncrypt from 'jsencrypt'
import modal from './util/modal.js'

// import "./assets/js/common";
// import "./assets/js/wow.min"
import WOW from 'wowjs';
Vue.prototype.$jsEncrypt = JsEncrypt
import VueRouter from "vue-router";
Vue.prototype.$wow = WOW;
Vue.prototype.$modal = modal

import Pagination from "./components/Pagination";
Vue.component('Pagination', Pagination)

new Vue({
  el:'#app',
  router,
  store,
  render: h=>h(App)
});



// WEBPACK FOOTER //
// ./src/main.js